import React from 'react';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import CloseIcon from '@mui/icons-material/Close';
import { TableData } from '../types';

interface DrawerHeaderProps {
  selectedTable: TableData | null;
  isTableSpecificView: boolean;
  tableNameFromUrl: string | null;
  isSyncing: boolean;
  onBackClick: () => void;
  onManualRefresh: () => void;
  onClose: () => void;
}

export const DrawerHeader: React.FC<DrawerHeaderProps> = ({
  selectedTable,
  isTableSpecificView,
  tableNameFromUrl,
  isSyncing,
  onBackClick,
  onManualRefresh,
  onClose
}) => {
  return (
    <div style={{ 
      display: 'flex', 
      justifyContent: 'space-between', 
      alignItems: 'center', 
      padding: '16px 20px', 
      borderBottom: '1px solid #e5e7eb',
      backgroundColor: '#f8fafc'
    }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
        {selectedTable && (
          <IconButton onClick={onBackClick} size="small">
            <ArrowBackIcon />
          </IconButton>
        )}
        <Typography variant="h6" sx={{ 
          fontWeight: 600, 
          color: '#1f2937',
          maxWidth: '180px',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap'
        }}>
          {selectedTable 
            ? selectedTable.tableName 
            : (isTableSpecificView && tableNameFromUrl 
                ? `Table ${tableNameFromUrl}` 
                : 'Tables & Attendees')}
        </Typography>
      </div>
      <div style={{ 
        display: 'flex', 
        alignItems: 'center', 
        gap: '8px',
        marginLeft: 'auto' // Ensure buttons are pushed to the right
      }}>
        <Button
          onClick={onManualRefresh}
          disabled={isSyncing}
          size="small"
          variant="outlined"
          sx={{ 
            minWidth: 'auto', 
            padding: '4px 12px',
            height: '32px',
            fontSize: '0.875rem',
            whiteSpace: 'nowrap'
          }}
        >
          {isSyncing ? 'Syncing...' : 'Sync Now'}
        </Button>
        <IconButton 
          onClick={onClose} 
          size="small"
          sx={{ 
            ml: 1,
            width: '32px',
            height: '32px'
          }}
        >
          <CloseIcon sx={{ fontSize: 20 }} />
        </IconButton>
      </div>
    </div>
  );
}; 